<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        :v-model="query"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索" prop="name">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="企业">
          <el-select
            v-model="query.companyID"
            filterable
            clearable
            @change="getList()"
          >
            <el-option
              v-for="item in accompany"
              :label="item.shortName"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缴费">
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = { isEnable: true };
              miniIDList=[];
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>项目列表</span>
        </div>
        <el-tabs v-model="query.state" @tab-click="selList()">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane
            :label="item.name"
            :key="item.id"
            :name="item.id.toString()"
            v-for="item in stateList"
          ></el-tab-pane>
        </el-tabs>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="name" label="项目名称"></el-table-column>
          <el-table-column
            prop="companyName"
            label="所属公司"
          ></el-table-column>
          <el-table-column
            prop="serverName"
            label="服务器名称"
          ></el-table-column>
          <!-- <el-table-column prop="typeName" label="项目类型"></el-table-column> -->
          <el-table-column prop="stateName" label="项目状态"></el-table-column>
          <el-table-column prop="linkName" label="联系人"></el-table-column>
          <el-table-column prop="feeTime" label="付费日期"></el-table-column>
          <el-table-column prop="serverFee" label="租赁费"></el-table-column>
          <el-table-column prop="serviceFee" label="服务费"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="通知详情" placement="top">
                  <a target="_blank" :href="'/vue/notice?id=' + scope.row.id">
                    <el-button
                      type="warning"
                      size="mini"
                      icon="el-icon-bell"
                    ></el-button>
                  </a>
                </el-tooltip>
                <el-tooltip content="合同管理" placement="top">
                  <a :href="'/vue/contract?id=' + scope.row.id" target="_blank">
                    <el-button
                      type="success"
                      size="mini"
                      icon="el-icon-files"
                    ></el-button>
                  </a>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑项目信息' : '添加项目信息'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="项目名称"
          prop="name"
          :rules="[{ required: true, message: '请输入项目名称' }]"
        >
          <el-input v-model="form.name" placeholder="请输入项目名称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="开始时间"
                style="width: 166px"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束时间"
                style="width: 166px"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="项目简介" prop="summary">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属公司" prop="companyID">
              <el-select v-model="form.companyID" filterable>
                <el-option
                  v-for="item in reverseCompany"
                  :label="item.shortName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="服务器" prop="serverID">
              <el-select v-model="form.serverID" filterable>
                <el-option
                  v-for="item in serverlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="小程序" prop="miniIDList">
              <el-select v-model="miniIDList" multiple>
                <el-option
                  v-for="item in minilist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="项目类型"
              prop="type"
              :rules="[{ required: true, message: '请输入小程序类型' }]"
            >
              <el-select v-model="form.type" filterable>
                <el-option
                  v-for="item in typeList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="状态"
              prop="state"
              :rules="[{ required: true, message: '请选择状态' }]"
            >
              <el-select v-model="form.state" filterable>
                <el-option
                  v-for="item in stateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="维护费"
              prop="serviceFee"
              :rules="[
                { required: true, message: '请填写网络维护费' },
                { type: 'number', message: '请填写数字' },
              ]"
            >
              <el-input v-model.number="form.serviceFee"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="租用费"
              prop="serverFee"
              :rules="[
                { required: true, message: '请输入服务器租用费' },
                { type: 'number', message: '请填写数字' },
              ]"
            >
              <el-input v-model.number="form.serverFee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="收费日期"
          prop="feeTime"
          :rules="[{ required: true, message: '请填写收费日期' }]"
        >
          <el-date-picker
            v-model="form.feeTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择收费日期"
          ></el-date-picker>
        </el-form-item>

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item
              label="联系人"
              prop="linkName"
              :rules="[{ required: true, message: '请填写联系人' }]"
            >
              <el-input v-model="form.linkName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="mobile">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="微信" prop="wechat">
          <el-input v-model="form.wechat"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import dataHelper from "@/plugins/dataHelper.js";
export default {
  data() {
    return {
      key: "",
      accompany: [], //企业列表
      serverlist: [], //服务器列表
      minilist: [], //小程序列表
      miniIDList: [], //选中小程序id列表
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      stateList: dataHelper.getProjectState(),
      typeList: [
        {
          id: 1,
          name: "内部项目",
        },
        {
          id: 2,
          name: "合作项目",
        },
        {
          id: 3,
          name: "外包项目",
        },
      ],
    };
  },
        computed:{
    reverseCompany:function(){
      return this.accompany.slice(0).reverse();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    //获取项目列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (params.daterange) {
        params.payStart = params.daterange[0];
        params.payEnd = params.daterange[1];
      } else {
        params.payStart = "";
        params.payEnd = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getProject("getlist");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取企业列表
    company: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAccInfo("GetAll_Commany");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.accompany = data;
      });
    },
    //获取服务器列表
    serverList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getAccInfo("getall_server");
      $.get(link, params, (data) => {
        _this.serverlist = data;
      });
    },
    //获取小程序列表
    getMiniList: function () {
      var _this = this;
      var link = url.getAccInfo("getlist_minienable");
      $.get(link, {}, (data) => {
        _this.minilist = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getProject("addorupdate");
      var info = this.form;
      info.miniIDList = this.miniIDList.toString();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      var list = row.miniIDList == null ? [] : row.miniIDList.split(",");
      for (var i = 0; i < list.length; i++) {
        list[i] = parseInt(list[i]);
      }
      this.miniIDList = list;
      this.dialogVisible = true;
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getProject("delete"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  mounted() {
    //   项目列表
    this.getList();
    //获取服务器列表
    this.serverList();
    //获取企业列表
    this.company();
    // 小程序列表
    this.getMiniList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>

